import { Modal, Form, Input, Button, message } from "antd";
import { IoCloseCircleOutline } from "react-icons/io5";
import { PiInfoBold } from "react-icons/pi";

const ExcelDownloadModal = ({
  isModalOpen,
  setIsModalOpen,
  onClickDownload,
  forDelete = false,
  title = "Bulk Download Confirmation",
  desc = "To proceed with the bulk download, please enter your username and password below",
  confirmBtnText = "Confirm",
}) => {
  const [form] = Form.useForm();
  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const handleDownload = () => {
    form
      .validateFields()
      .then((values) => {
        const { username, password } = values;
        if (username === "HealthSy" && password === "7TcvKsL9Ug%3A4TF") {
          onClickDownload();
          if (!forDelete) {
            message.success("Access granted! Starting download...");
          }
          setIsModalOpen(false);
        } else {
          message.error("Invalid username or password.");
        }
      })
      .catch((info) => {
        console.log("Validation Failed:", info);
      });
  };

  return (
    <div className="exportDwnWrapper">
      <Modal
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={500}
        title={
          <div className="text-center mb-2">
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: "50%",
                backgroundColor: "#fde8ef",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PiInfoBold size={24} color="#cc0e49" />
            </div>
          </div>
        }
        closeIcon={<IoCloseCircleOutline size={24} />}
        style={{ padding: "32px" }}
        centered
      >
        <h2 className="fw-bold mb-2" style={{ fontSize: "20px" }}>
          {title}
        </h2>
        <p className="mb-4" style={{ color: "#6b7280" }}>
          {desc}
        </p>

        <Form form={form} layout="vertical" name="download_form">
          <Form.Item
            label="User Name"
            name="username"
            rules={[{ required: true, message: "Please enter your username!" }]}
          >
            <Input
              placeholder="Enter your name"
              style={{ backgroundColor: "#f9f9f9", borderRadius: "8px" }}
            />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please enter your password!" }]}
          >
            <Input.Password
              placeholder="Enter your password"
              style={{ backgroundColor: "#f9f9f9", borderRadius: "8px" }}
            />
          </Form.Item>
        </Form>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <Button
            onClick={handleCancel}
            style={{
              borderColor: "#cc0e49",
              color: "#cc0e49",
              borderRadius: "8px",
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={handleDownload}
            style={{
              backgroundColor: "#cc0e49",
              borderColor: "#cc0e49",
              borderRadius: "8px",
            }}
          >
            {confirmBtnText}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default ExcelDownloadModal;
